<template>
    <div>
        <app-header></app-header>
        <div class="grid-container pad-top--xl pad-bottom--xl">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-8 medium-offset-2">
                    <h1>Sitemap</h1>
                    <ul>
                        <router-link
                            to="/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/
                        </router-link>
                        <router-link
                            to="/why-choose-us/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/why-choose-us/
                        </router-link>
                        <router-link
                            to="/customisation/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/customisation/
                        </router-link>
                        <router-link
                            to="/how-to-order/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/how-to-order/
                        </router-link>
                        <router-link
                            to="/bulk-order/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/bulk-order/
                        </router-link>
                        <router-link
                            to="/garments/all/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/garments/all/
                        </router-link>
                        <router-link
                            to="/organic-sustainable/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/organic-sustainable/
                        </router-link>
                        <router-link
                            to="/brands-that-trust-us/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/brands-that-trust-us/
                        </router-link>
                        <router-link
                            to="/loyalty-scheme/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/loyalty-scheme/
                        </router-link>
                        <router-link
                            to="/order/design/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/order/design/
                        </router-link>
                        <router-link
                            to="/contact-us/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/contact-us/
                        </router-link>
                        <router-link
                            to="/delivery/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/delivery/
                        </router-link>
                        <router-link
                            to="/checkout/basket/"
                            tag="li"
                            class="link">
                            https://customisedclothing.com/checkout/basket/
                        </router-link>
                        <router-link
                            v-for="(garment, index) in garments"
                            v-bind:key="index"
                            v-bind:to="`https://customisedclothing.com${garment.url}`"
                            tag="li"
                            class="link">
                            https://customisedclothing.com{{ garment.url }}
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'Sitemap',
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
    data() {
        return {
            garments: [],
        };
    },
    methods: {
        getSitemap() {
            axios.get('/Sitemap/getUrls.json')
                .then((response) => {
                    this.garments = response.data.response.garments;
                });
        },
    },
    mounted() {
        this.getSitemap();
    },
};
</script>


// WEBPACK FOOTER //
// src/components/StaticPages/Sitemap.vue